import { z } from 'zod/v4';
export const FDADeviceClassificationDbSearchInputSchema = z.object({
    deviceName: z.string(),
    productCode: z.string().optional(),
    regulationNumber: z.string().optional(),
});
export const FDADeviceClassificationDbSearchOutputSchema = z.object({
    meta: z.object({
        total: z.number(),
        limit: z.number(),
        skip: z.number(),
    }),
    search_query_built: z.string(),
    search_criteria: z.object({
        deviceName: z.string().optional(),
        productCode: z.string().optional(),
        regulationNumber: z.string().optional(),
    }),
    api_url: z.string(),
    devices: z.array(z.object({
        reviewPanel: z.string().nullable(),
        medicalSpecialty: z.string().nullable(),
        productCode: z.string(),
        deviceName: z.string().nullable(),
        deviceClass: z.string().nullable(),
        unclassifiedReasonCode: z.string().nullable(),
        gmpExemptFlag: z.string().nullable(),
        thirdPartyReviewEligible: z.string().nullable(),
        thirdPartyReviewCode: z.string().nullable(),
        regulationNumber: z.string().nullable(),
        submissionTypeId: z.string().nullable(),
        definition: z.string().nullable(),
        implantFlag: z.string().nullable(),
        lifeSustainSupportFlag: z.string().nullable(),
        summaryMalfunctionReporting: z.string().nullable(),
    })),
});
//# sourceMappingURL=fda-device-classification-db-search.js.map